module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Slot/images/slot-75.de628ecb.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Slot/images/slot-75.png
// module id = 3365
// module chunks = 11